import { render, staticRenderFns } from "./UiRoundImage.vue?vue&type=template&id=30f4cbac&"
import script from "./UiRoundImage.vue?vue&type=script&lang=js&"
export * from "./UiRoundImage.vue?vue&type=script&lang=js&"
import style0 from "./UiRoundImage.vue?vue&type=style&index=0&id=30f4cbac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports